<template>
  <div v-if="showDirectiveDashboard" class="directive-dash">
    <div class="directive-dash__panel">
      <Card class="dashboard-card" :hide_title="true">
        <template v-slot:content>
          <NewGenericBTable
            :fields="fields"
            :url="'/mesh/directive-dashboard/'"
            :pagination="10"
            :view_filter_by="false"
            @total_items="setTotalItems"
          >
            <!-- Carrera del Perfil de Egreso -->
            <template #cell(career_name)="row">
              <div class="text-left">
                {{ row.item.career_name }}
                <span v-if="row.item.code" class="kl-chip ml-1">{{
                  row.item.code
                }}</span>
              </div>
            </template>
            <!-- Cantidad de Asignaturas -->
            <template #cell(egress_profile_matters)="row">
              {{ row.item.egress_profile_matters.length }}
            </template>
            <!-- Total de Secciones Activas -->
            <template #cell(active_sections)="row">
              <span
                class="kl-chip"
                :class="{
                  'kl-chip--solid': totalActiveSections(row.item) > 0,
                }"
              >
                {{ totalActiveSections(row.item) }}
              </span>
            </template>
            <!-- Detalle (expandir Asignaturas) -->
            <template #cell(details)="row">
              <b-button
                size="sm"
                variant="none"
                class="btn-toggle-details noprint"
                v-b-tooltip.v-secondary.left.noninteractive="
                  row.detailsShowing
                    ? $t('dashboard.directiveDashboard.hideEntity', {
                        entity: $getVisibleNames(
                          'mesh.egressprofilematter',
                          true,
                          'Asignaturas'
                        ),
                      })
                    : $t('dashboard.directiveDashboard.showEntity', {
                        entity: $getVisibleNames(
                          'mesh.egressprofilematter',
                          true,
                          'Asignaturas'
                        ),
                      })
                "
                @click="row.toggleDetails"
              >
                <b-icon
                  :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'"
                ></b-icon>
              </b-button>
            </template>
            <!-- Sub-tabla: Asignaturas del Perfil de Egreso (con buscador local,
            scroll acotado y secciones colapsadas) -->
            <template #row-details="row">
              <DirectiveDashboardMatters
                :egress_profile="row.item"
              ></DirectiveDashboardMatters>
            </template>
          </NewGenericBTable>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "DirectiveDashboard",
  components: {
    Card: () => import("@/components/users/Card"),
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    DirectiveDashboardMatters: () =>
      import("@/components/users/DashboardCards/DirectiveDashboardMatters"),
  },
  data() {
    return {
      directive_groups: [
        "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
        "DIRECTIVOS ACADÉMICOS (CAMPUS)",
        "DIRECTIVOS FACULTAD O ESCUELA",
        "DIRECTORES DE CARRERA",
        "DIRECTORES DE CARRERA (CAMPUS)",
        "ADMINISTRATIVOS INSTRUCCIONALES",
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
    showDirectiveDashboard() {
      if (!this.user) return false;
      return (
        this.directive_groups.some((group) =>
          this.user.group_names.includes(group)
        ) || this.user.is_superuser
      );
    },
    fields() {
      return [
        {
          key: "career_name",
          label: this.$getVisibleNames("mesh.career", false, "Carrera"),
          sortable: true,
          // El alias del serializer no existe en la base: se ordena por la relación
          ordering_key: "career__name",
          display_column: true,
        },
        {
          key: "egress_profile_matters",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ),
          sortable: false,
          display_column: true,
          thStyle: { width: "14%" },
        },
        {
          key: "active_sections",
          label: this.$t("dashboard.directiveDashboard.activeEntity", {
            entity: this.$getVisibleNames(
              "teaching.section",
              true,
              "Secciones"
            ),
          }),
          sortable: false,
          display_column: true,
          thStyle: { width: "16%" },
        },
        {
          key: "details",
          label: this.$t("dashboard.dashboardView.options"),
          sortable: false,
          display_column: true,
          thStyle: { width: "8%" },
        },
      ];
    },
  },
  methods: {
    setTotalItems(count) {
      this.$emit("count", count);
    },
    totalActiveSections(egress_profile) {
      return egress_profile.egress_profile_matters.reduce(
        (acc, matter) => acc + (matter.active_sections_count || 0),
        0
      );
    },
  },
};
</script>

<style scoped>
.directive-dash {
  margin-bottom: 18px;
}
/* Marco moderno de la tarjeta (mismo estándar que el dashboard del profesor) */
.dashboard-card {
  display: block;
  margin: 0;
}
.dashboard-card >>> .card-container {
  background: var(--kl-surface);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-card-radius);
  box-shadow: 0 2px 4px rgba(16, 38, 73, 0.06);
  overflow: hidden;
}
.dashboard-card >>> .card-body {
  background: var(--kl-surface) !important;
  padding: 16px;
}
/* La tabla genérica ya trae su propio margen; se compacta dentro de la card */
.dashboard-card >>> .b-table-container {
  margin: 0;
}
/* Botón para expandir/colapsar el detalle de asignaturas */
.btn-toggle-details {
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-radius-md);
  color: var(--kl-color-primary);
  padding: 2px 8px;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.btn-toggle-details:hover {
  background: var(--kl-surface-hover);
  border-color: var(--kl-color-accent-border);
}
</style>
